import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Dashboard/Breadcrumbs/Breadcrumb';
import { Link } from 'react-router-dom';
import SelectGroupTwo from '../../../components/Dashboard/Forms/SelectGroup/SelectGroupTwo';
// import CKeditorComponent from '../../../components/cKeditor/CKeditor';
import { useForm } from 'react-hook-form';
import { Flip, ToastContainer, toast } from 'react-toastify';

import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useAuth from '../../../hooks/useAuth';
import { PromotionsComp } from '../../../components/Dashboard/Promotions/PromotionsComp';
import ImageUploader from '../../../components/Dashboard/ImageUploader/ImageUploader';
import SearchImage from '../../../components/Dashboard/searchImage/SearchImage';

interface ImageData {
  imageURL: string;
  imageCopyright:String;
}

const CreateArticle = () => {
  const [title,setTitle] = useState('');
  const [titleUrl,setTitleUrl] = useState('');
  const [date,setDate]= useState('');
  const [pubServerDate,setpubServerDate] = useState<Date>();
  const axiosPrivate = useAxiosPrivate();
  const {authenticated}  = useAuth();
  const [open,setisOpen] = useState(false);
  const [openSearch,setopenSearch] = useState(false);
  const [imageData,setImageData] = useState<ImageData | null>(null);
  const [imageid,setImageid] = useState();

  const handleImageInput = (childData)=>{
    console.log(childData,"this is parent data")
    setImageData(childData);
    setImageid(childData?.imageId);
  }


  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();
 const CategoryData = ['news','videos']
 const HTMLData = ['NO','YES']

 const handleUpdateDateTime = (e) =>{
  e.preventDefault();
  
  const newdate = new Date();

  const Datemy = newdate.getDay() + "-" + newdate.getMonth() +"-"+newdate.getFullYear();
  const showTime = newdate.getHours()
      + ':' + newdate.getMinutes() 
      + ":" + newdate.getSeconds();
      // console.log(Datemy+ " " +newdate.getMinutes())
setDate(Datemy+ " " +showTime);

setpubServerDate(newdate);
 }

 useEffect(()=>{
 
  const newdate = new Date();
  const Datemy = newdate.getDay() + "-" + newdate.getMonth() +"-"+newdate.getFullYear();
    const showTime = newdate.getHours()
        + ':' + newdate.getMinutes() 
        + ":" + newdate.getSeconds();
        console.log(Datemy+ " " +newdate.getMinutes())
setDate(Datemy+ " " +showTime);
setpubServerDate(newdate);

// console.log(authenticated?.user)

 },[])


  return (
    <>
    <div className='relative'>
      {open == false && openSearch == false  ?  (<div className='fixed mt-18 right-0 top-14  right-4'>
      <div className="flex flex-col items-center w-16 h-full overflow-hidden text-gray-400 bg-gray-900 rounded">
    <button className="flex items-center justify-center mt-3" onClick={()=>{
      setisOpen(!open)
    }}>
      <svg className="w-8 h-8 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path
          d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
      </svg>
    </button>
    <div className="flex flex-col items-center mt-3 border-t border-gray-700">
      <button onClick={()=>{
       setopenSearch(!openSearch)
      }}  className="flex items-center justify-center w-12 h-12 mt-2 rounded hover:bg-gray-700 hover:text-gray-300" >
        <svg className="w-6 h-6 stroke-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      </button>
  
    </div>
  

  </div>
      </div>):""}
      
      {open == true?   ( <div className='fixed mt-18 me-5 top-14 right-4 '>
        
        <div className="flex flex-col items-center w-64 h-full overflow-hidden text-gray-400 bg-gray-900 rounded">
      <button className="flex items-center w-full px-3 mt-3"  onClick={()=>{
      setisOpen(!open)
    }}>
        <svg className="w-8 h-8 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path
            d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
        </svg>
        <span className="ml-2 text-sm font-bold">Upload Image</span>
      </button>
      <div className="w-full px-2">
        <div className="flex flex-col items-center w-full mt-3 border-t border-gray-700">
        <div>
      {/* <PromotionsComp title="" id={3} /> */}

        </div>
  
        </div>
      
      </div>
      <div className="flex items-center justify-center w-full  mt-auto bg-gray-800 hover:bg-gray-700 hover:text-gray-300"
      >
        <ImageUploader/>
      
      </div>
    </div>
        </div>):""
       }
          {openSearch == true?   ( <div className='fixed mt-18 me-5 top-14 right-4 '>
        
        <div className="flex flex-col items-center w-64 h-full overflow-hidden text-gray-400 bg-gray-900 rounded">
      <button className="flex items-center w-full px-3 mt-3"  onClick={()=>{
      setopenSearch(!openSearch)
    }}>
        <svg className="w-8 h-8 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path
            d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
        </svg>
        <span className="ml-2 text-sm font-bold">Search/insert Image</span>
      </button>
      <div className="w-full px-2">
        <div className="flex flex-col items-center w-full mt-3 border-t border-gray-700">
        <div>
      {/* <PromotionsComp title="" id={3} /> */}

        </div>
  
        </div>
      
      </div>
      <div className="flex items-center justify-center w-full  mt-auto bg-gray-800 hover:bg-gray-700 hover:text-gray-300"
      >
       <SearchImage imageValue={handleImageInput}/>
      
      </div>
    </div>
        </div>):""
       }
   

   
      {/* <Breadcrumb pageName="Calendar" /> */}

      {/* <!-- ====== Create Section Start ====== --> */}
      <ToastContainer />
    
      <div className="flex justify-center gradient-Primary items-center py-5  rounded-xl shadow-lg mx-4">
        <h1 className="text-3xl font-bold text-white">Create Article</h1>
      </div>
      <div className="w-full max-w-full rounded-xl  bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <form   id="create-article"  onSubmit={ handleSubmit(async (data) => {
        console.log("Onsubmit",data)
            // setDisabled(true);
            console.log(data,"this is data");
            const formData = {
              category: data.category,
              title: data.title,
              titleSlug:titleUrl,
              introduction: data.introduction,
              imageCopyright:imageData?.imageCopyright,
              idImage:imageid,
              imageURL:imageData?.imageURL,
              htmlfilters:data.htmlfilters,
              pubDate:data.pubDate,
              pubServerDate:pubServerDate,
              articleData: data.articleData,
              
            };
            console.log(formData,"this is form data")

          await  axiosPrivate.post("/article/createArticle",formData,{withCredentials:true}).then((res)=>{
              console.log(res.data)
            }).catch((err)=>console.log(err))

         
          })} className="my-4 p-4">
            <input type="hidden" name="setmenu_name" />
            <input type="hidden" name="action" />
            
            <br />
          {/* <SelectGroupTwo     id="1" title="Category" dropdownData={CategoryData}/>
               */}
    <div>
      <label className="block">Category</label>
      <select
      
      {...register("category", {
        required: "This field is required.",
        
      })} 
        className="rounded border"
      >
        <option value="" disabled>
          Select Category
        </option>
        {CategoryData.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
        
      </select>
    </div>
       
          
            <div>
              <label className="my-3 block text-black dark:text-white">
                Title*
              </label>
              <input  {...register("title", {
                  required: "This field is required.",
                  
                })} 
                type="text"
                value={title}
                onChange={(e)=>{
                  setTitle(e.target.value)
                  const newTitle = e.target.value.replace(/ /g, "-");
                  setTitleUrl(newTitle)
                }}
                
                placeholder="Default Input"
                className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
            </div>
           
            <div>
              <label className="my-3 block text-black dark:text-white">
           Title Used for url
              </label>
              <input
           
              value={titleUrl}
              disabled
                type="text"
                placeholder="Default Input"
                className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
            </div>
            {/* <b>Twitter Link</b>
            <input type="text" name="twitter" value="" /> */}
            <div>
              <label className="my-3 block text-black dark:text-white">
                Introduction
              </label>
              <input
               {...register("introduction", {
                required: "This field is required.",
                
              })} 
                type="text"
                placeholder="Default Input"
                className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
            </div>
            {/* <b>Linkedin Link</b>
            <input type="text" name="linkedin" value="" /> */}
            <div>
              <label className="my-3 block text-black dark:text-white">
                Image Copyright
              </label>
              <input
          
                value={ (imageData?.imageCopyright ?? "") as string}
                type="text"
                placeholder="Default Input"
                className="w-3/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
            </div>
            <div>
              <label className="my-3 block text-black dark:text-white">
                ID Image
              </label>
              <div className='flex'>
                <div>

              <input
                value={imageid} 
                required
                type="number"
                // defaultValue={null}
                placeholder="Default Input"
                className="w-2/5 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
                </div>
              {imageid != null ?(<div>
              <img  src={ imageData ? (imageData?.imageURL):""} style={{height:"80px"}} /></div>):""}
              </div>

            </div>
            <div className='flex my-3 items-center'>
              <div>
              <label className=" block text-black dark:text-white">
               Pub Date/Time : 
              </label>
           
              </div>
              <div className='flex'>
              <input

{...register("pubDate")} 
                value={date}
                type="text"
                onChange={(e)=>{
                  setDate(e.target.value);
                }}    
                placeholder="Default Input"
                className="w-3/5 mx-2 rounded-lg border-[1.5px] border-stroke bg-transparent py-1 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
              />
                <button
                onClick={handleUpdateDateTime} 
              className="inline-flex items-center justify-center rounded-md border border-primary py-1 px-10 text-center font-medium text-primary hover:bg-opacity-90 lg:px-8 xl:px-10"
              > Update</button>
              </div>
            </div>
            <label>Last Updated : </label>
            
            <div>
      <label className="block">HTML Filters</label>
      <select
{...register("htmlfilters")} 
      
    
        className="rounded border"
      >
        <option value="" disabled>
          Select HTML
        </option>
        {HTMLData.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
        
      </select>
    </div>
            
            <div className='mt-2'>
              <h2>Article Page:</h2>
              {/* <div className="mt-5">
          <CKeditorComponent  value=""   
           onChange={(event, editor) => {
                  const data = editor.getData();
                  
                  setValue("articleData", data); // Set the CKEditor data to the form
                }}
// {...register("ckEditor")} 
          
          />
        </div> */}
            </div>
            <div className='mt-3'>

            <button
            type='submit'
            onClick={()=>{
           
            }}
             
              className="inline-flex items-center justify-center rounded-md border border-primary py-1 px-10 text-center font-medium text-primary hover:bg-opacity-90 lg:px-8 xl:px-10"
            >
              Create Article
            </button>
            </div>
          </form>
      </div>
      {/* <!-- ====== Create Section End ====== --> */}
   
</div>
    </>
  );
};

export default CreateArticle;


